import styled from "styled-components";

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const EducationGrid = styled.div`
  width: 100%;
  max-width: 1304px;
  margin: 0 auto;

  display: grid;
  grid-template-columns: repeat(3, max-content);
  justify-content: center;
  column-gap: 30px;
  row-gap: 88px;

  @media (min-width: 1400px) {
    column-gap: 32px;
  }

  @media (max-width: 1023px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    justify-content: stretch;
    column-gap: 15px;
    row-gap: 30px;
  }
`;

export const GridItem = styled.div`
  /* Normal education cards: compact card sized to rendered image */
  width: fit-content;
  max-width: 100%;

  & > div[class*="ProductsItemstyle__Root"] {
    width: fit-content !important;
    max-width: 100% !important;
  }

  /* Match image width → body width, keep heart on image corner */
  & div[class*="ProductsItemstyle__Container"] {
    width: fit-content !important;
    max-width: 100% !important;
  }

  & a[class*="ProductsItemstyle__ImageContainer"] {
    width: auto !important;
    max-width: 100% !important;
  }

  & a[class*="ProductsItemstyle__ImageContainer"] img {
    width: auto !important;
    max-width: 100% !important;
    height: 100% !important;
    object-fit: contain !important;
  }

  & div[class*="ProductsItemstyle__Body"] {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
    padding-right: 0 !important;
  }
`;

export const GridItemWide = styled(GridItem)`
  @media (min-width: 1024px) {
    /* Force exact start/end columns for perfect alignment */
    grid-column: 2 / 4;
  }

  /* Wide card should fill the spanned grid area (override compact rules above) */
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;

  & > div[class*="ProductsItemstyle__Root"] {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
  }

  & div[class*="ProductsItemstyle__Container"] {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
  }

  & div[class*="ProductsItemstyle__Body"] {
    width: auto !important;
    padding-right: 0 !important;
  }
`;
